module.exports = __webpack_public_path__ + "static/media/logo-norwegian.9a4079d2.png";